module.exports = __webpack_public_path__ + "static/media/spades_6.f8803e04.png";